import Reveal from './Reveal';
import chaos1400 from '@/assets/home-left-1400.webp.asset.json';
import chaos700 from '@/assets/home-left-700.webp.asset.json';

const lines = [
  {
    head: 'You sent it. Then silence.',
    sub: 'A PDF can’t tell you who opened it or what they looked at, so you don’t know who to call.',
  },
  {
    head: 'They wanted it. You never knew.',
    sub: 'A buyer looked twice at one listing, heard nothing, and bought from someone else.',
  },
  {
    head: 'By the time you followed up, it had sold.',
    sub: 'Inventory moves in days. The price list you sent last week is already wrong.',
  },
  {
    head: 'It never went out at all.',
    sub: 'Building a clean menu takes so long that some listings never get offered.',
    quote: {
      text: '“I’ve left a lot of opportunities out there because it’s just not ready to go to be broadcasted.”',
      who: 'Grower and operator, Washington',
    },
  },
];

const QuietCost = () => (
  <section className="border-b border-border bg-background py-20 md:py-24">
    <div className="container-wide grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <div>
        <Reveal className="max-w-2xl">
          <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">
            What a stale menu costs you
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            You send buyers a spreadsheet, a PDF or a group-chat post. Then nothing comes back: no
            sign of who opened it, which listing caught their eye, or whether the price still
            holds. Most sellers lose deals here without ever knowing it.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-6">
          {lines.map((l, i) => (
            <Reveal key={l.head} delay={i * 90}>
              <div className="border-l-2 border-brand/70 pl-5">
                <p className="text-lg font-medium">{l.head}</p>
                <p className="mt-2 text-sm text-muted-foreground">{l.sub}</p>
                {l.quote && (
                  <figure className="mt-3">
                    <blockquote className="text-sm italic text-foreground/80">{l.quote.text}</blockquote>
                    <figcaption className="mt-1 text-xs text-muted-foreground">{l.quote.who}</figcaption>
                  </figure>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* The reader's own Tuesday: chat threads asking for the menu, seven
          "final" spreadsheets, a stale printout. Recognition lands faster
          than explanation, so this sits beside the copy rather than under it. */}
      <Reveal delay={120} className="order-first lg:order-none">
        <img
          src={chaos1400.url}
          srcSet={`${chaos700.url} 700w, ${chaos1400.url} 1400w`}
          sizes="(min-width: 1024px) 44vw, 90vw"
          width={1400}
          height={1547}
          loading="lazy"
          decoding="async"
          alt="How menus travel today: buyers asking over chat for the latest menu, a pile of spreadsheet and PDF versions named Menu_NEW, Menu_v3 and Menu_v7_FINAL_final, and a printed price sheet marked out of date."
          className="mx-auto w-full max-w-md rounded-xl saturate-[0.85] lg:max-w-none lg:rotate-[-1.5deg]"
        />
      </Reveal>
    </div>
  </section>
);

export default QuietCost;
